<template>
    <div id="tryout-chooser">
        <v-btn
            block
            class="font-weight-bold blew--text"
            depressed
            color="#E3F2FD"
            @click="newInitData()"
            id="tryout_chooser_tambah_kelas"
        >
            <v-icon style="font-size: 16px !important">mdi-plus-circle</v-icon>
            Tambah Kelas
        </v-btn>

        <v-dialog
            v-model="showModal"
            transition="dialog-top-transition"
            width="940px"
            min-height="537px"
            max-height="771px"
            @click:outside="showModal = false"
        >
            <template v-slot:default="dialog">
                <v-card>
                    <v-card-text width="100%">
                        <app-datatable
                            :items="rows"
                            :headers="headers"
                            :hasAction="false"
                            :has-custom-pagination="false"
                            :custom-pagination-current-page="1"
                            :custom-pagination-per-page="10"
                            :has-custom-search="false"
                            v-on:dblClicked="tryoutSelected($event)"
                            v-on:selected="selectedRow = $event"
                        ></app-datatable>
                    </v-card-text>
                    <v-card-text>
                        <div class="text-h2"></div>
                    </v-card-text>
                    <v-card-actions class="justify-end">
                        <v-btn text @click="dialog.value = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </template>
        </v-dialog>

        <app-spinner v-if="isLoading"></app-spinner>
    </div>
</template>

<style>
.modal-body {
    overflow: auto;
}
</style>

<script>
import DataTable from "@/modules/global/components/plugins/DataTable-c";
import SalesService from "@/modules/global/services/sales.js";
import Spinner from "@/modules/global/components/plugins/Spinner";

export default {
    name: "tryout-chooser",

    components: {
        "app-datatable": DataTable,
        "app-spinner": Spinner,
    },

    props: ["isInstant"],

    data: function () {
        return {
            isLoading: false,
            showModal: false,
            headers: [
                { text: "ID", value: "id" },
                { text: "Deskripsi", value: "description" },
                { text: "Kuota", value: "quota" },
                { text: "Threshold", value: "threshold" },
                { text: "Start", value: "start_time" },
                { text: "End", value: "end_time" },
            ],
            headersKey: [
                "id",
                "description",
                "quota",
                "threshold",
                "start_time",
                "end_time",
            ],
            rows: [],
            selectedRow: null,
        };
    },

    watch: {
        pagination: function () {
            this.reloadDataAndOpenModal();
        },
    },

    methods: {
        tryoutSelected: function (tryout) {
            this.$emit("selected", tryout);
            this.showModal = false;
        },

        closemodal() {
            this.showModal = false;
        },

        newInitData: function () {
            this.rows = [];
            this.reloadDataAndOpenModal();
            this.showModal = true;
        },

        reloadDataAndOpenModal: function () {
            this.isLoading = true;
            var context = this;
            SalesService.getListJadwalKelas(function (result) {
                if (result.success) {
                    result.data.forEach(function (content, index) {
                        var row = {
                            no: index,
                            id: content.id,
                            description: content.description,
                            quota: content.quota,
                            threshold: content.threshold,
                            start_time: content.start_time,
                            end_time: content.end_time,
                        };
                        context.rows.push(row);
                    });

                    context.isLoading = false;
                    context.showModal = true;
                }
            });
        },
    },
};
</script>



// WEBPACK FOOTER //
// JadwalKelasChooser.vue?7bd8a02d